var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-calendar__card",
      class: [
        { "has-projects": _vm.hasProjects },
        { "is-holiday": _vm.isHoliday },
      ],
      on: { dblclick: _vm.directLinkToEntries },
    },
    [
      _c(
        "v-draggable",
        {
          staticClass: "c-calendar__card-content",
          attrs: {
            tag: "div",
            "data-date": _vm.$moment(_vm.date).format("YYYY-MM-DD"),
            "data-kolonne": _vm.kolonne_number,
            "data-weekdays": _vm.getWeekDayId,
            animation: "150",
            group: "week",
          },
          on: { end: _vm.onEndDrag },
          model: {
            value: _vm.daily_entries,
            callback: function ($$v) {
              _vm.daily_entries = $$v
            },
            expression: "daily_entries",
          },
        },
        [
          _vm.daily_entries.length > 0
            ? [
                _c("v-week-day-content", {
                  attrs: {
                    date: _vm.date,
                    index: _vm.index,
                    count: _vm.count,
                    comment: _vm.comment,
                    kolonne_number: _vm.kolonne_number,
                    first_entry: _vm.daily_entries[0],
                    daily_entries: _vm.daily_entries,
                    is_holiday: _vm.isHoliday,
                  },
                  on: { saveWeekDay: _vm.saveWeekDay },
                }),
              ]
            : _c("div", { attrs: { "data-draggable": "0" } }, [
                _c("div", [
                  _vm.comment
                    ? _c(
                        "span",
                        { staticClass: "c-calendar__comment u-color--primary" },
                        [_c("strong", [_vm._v(_vm._s(_vm.comment))])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-calendar__hover-tools" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "c-calendar__hover-tool-grid grid-x grid-margin-x",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "cell small-6" },
                          [
                            _c("v-week-day-comment-only", {
                              attrs: { comment: _vm.comment },
                              on: { saveWeekDay: _vm.saveWeekDay },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "cell small-6" }, [
                          _c(
                            "div",
                            { staticClass: "c-calendar__create-button" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "button button--action button--action--create button--small",
                                  attrs: {
                                    to: {
                                      name: "create-day",
                                      action: "create-new",
                                      params: {
                                        date: this.date,
                                        kolonne: this.kolonne_number,
                                      },
                                    },
                                    title: _vm.$t("weeks.project.add"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("weeks.project.add")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
          _vm._v(" "),
          _vm.triggerSpinner
            ? _c(
                "span",
                {
                  staticClass: "loading-wrapper is-loading",
                  staticStyle: { position: "absolute", width: "100%" },
                },
                [_c("span", { staticClass: "loading-message" })]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }